<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
  <g fill="#FFF" fill-rule="evenodd">
    <rect width="32" height="32" opacity=".3" rx="2"/>
    <path fill-rule="nonzero"
          d="M20.262 8.003L18.206 8c-2.31 0-3.803 1.532-3.803 3.902v1.8h-2.067a.323.323 0 0 0-.323.323v2.606c0 .179.145.324.323.324h2.067v6.577c0 .179.145.323.324.323h2.697a.323.323 0 0 0 .323-.323v-6.577h2.417a.323.323 0 0 0 .324-.324v-2.606a.324.324 0 0 0-.323-.324h-2.418v-1.525c0-.733.175-1.105 1.13-1.105h1.385a.323.323 0 0 0 .323-.324v-2.42a.323.323 0 0 0-.323-.324z"/>
  </g>
</svg>
